<label class="radio-container"><ng-content></ng-content>
    <input class="radio-body" type='radio' name="radio-{{groupName}}" [checked]="checkValue" (change)="valueChanged.emit($event)" [disabled]="isDisabled">
    <span class="radio-checkmark"></span>
</label>